var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wizard-price-base',{attrs:{"label":_vm.computedLabel,"editable":_vm.$attrs.editable},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }